module.exports = __webpack_public_path__ + "img/7.84b41cc4.png";